import { TableBody, TableCell, Grid, TableRow, Typography, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FilterIcon } from "src/assets/icons";
import { StyledTable, StyledTableHead } from "./styles";
import TnAApproverRow from "./TnAEmployeeApproversRow";
import { EmployeeApproversDTO } from "../../../models/employee-approver/employee-approver-dto";

interface Props {
  items: EmployeeApproversDTO[];
}

const TnAEmployeesApproversTable = ({ items }: Props) => {
  const tRP = "components.team_presence_and_leaves_approvers";
  const tRPCommon = "pages.company_account_profile.tables.employees.fields";
  const { t } = useTranslation();
  const theme = useTheme();
  const [onlyCurrentApprovers, setOnlyCurrentApporvers] = useState<boolean>(false);
  return (
    <>
      <StyledTable>
        <StyledTableHead>
          <TableRow>
            <TableCell
              align="center"
              rowSpan={2}
            >
              <Grid>
                <Typography>{`${t(`${tRPCommon}.employee_code`)} |`}</Typography>
                <Typography>{`${t(`${tRPCommon}.internal_id`)}`}</Typography>
              </Grid>
            </TableCell>
            <TableCell
              align="center"
              rowSpan={2}
            >{`${t("common_words.employee")} | ${t("common_words.legal_entity")}`}</TableCell>
            <TableCell
              align="center"
              rowSpan={2}
            >{`${t(`${tRP}.fields.presence_and_leaves_approver`)}`}</TableCell>
            <TableCell
              align="center"
              rowSpan={2}
            >{`${t(`${tRP}.fields.expense_report_approvers`)}`}</TableCell>
            <TableCell
              align="center"
              colSpan={2}
              width={"30%"}
            >{`${t(`${tRP}.fields.client_approvers`)}`}</TableCell>
          </TableRow>
          <TableRow>
            {/* <TableCell colSpan={4}></TableCell> */}
            <TableCell align="center">{`${t("common_words.project")}`}</TableCell>
            <TableCell align="center">
              <Grid
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {`${t("common_words.client")}`}

                <IconButton
                  style={{ width: "15px", height: "15px" }}
                  onClick={() => setOnlyCurrentApporvers(!onlyCurrentApprovers)}
                >
                  <FilterIcon
                    style={{ color: onlyCurrentApprovers ? theme.palette.secondary.light : theme.palette.primary.main }}
                  />
                </IconButton>
              </Grid>
              {onlyCurrentApprovers && (
                <Typography style={{ fontSize: "10px" }}>
                  ({`${t(`${tRP}.fields.filtered_to_current_approvers`)}`})
                </Typography>
              )}
            </TableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {items.map((item, idx) => (
            <TnAApproverRow
              key={idx}
              item={item}
              onlyCurrentClientApprover={onlyCurrentApprovers}
            />
          ))}
        </TableBody>
      </StyledTable>
    </>
  );
};
export default TnAEmployeesApproversTable;
